import axios from 'axios';
import AuthService from './auth-header';
// /*dev*/const API_URL = 'https://ats.sattvahuman.in/api/';
// /*prod*/ //const API_URL = 'https://ats.sattvahuman.in/api/';

let API_URL = ''
if (process.env.NODE_ENV === "production") {
  API_URL = 'https://ats.sattvahuman.in/api/';
} else {
  API_URL = 'http://192.168.0.30:5000/api/';
}

class FormsService {
  // Forms CRUD Operations
  async getAllForms() {
    try {
      const res = await axios.get(API_URL + 'forms/', {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async getFormById(id) {
    try {
      const res = await axios.get(API_URL + 'forms/' + id, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async createForm(formData) {
    try {
      const res = await axios.post(API_URL + 'forms/', formData, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async updateForm(id, formData) {
    try {
      const res = await axios.put(API_URL + 'forms/' + id, formData, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async deleteForm(id) {
    try {
      const res = await axios.delete(API_URL + 'forms/' + id, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async duplicateForm(id) {
    try {
      const res = await axios.post(API_URL + 'forms/' + id + '/duplicate', {}, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async archiveForm(id) {
    try {
      const res = await axios.patch(API_URL + 'forms/' + id + '/archive', {}, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async publishForm(id) {
    try {
      const res = await axios.patch(API_URL + 'forms/' + id + '/publish', {}, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async saveFormDraft(id, formData) {
    try {
      const res = await axios.patch(API_URL + 'forms/' + id + '/draft', formData, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Form Responses Operations
  async getFormResponses(formId) {
    try {
      const res = await axios.get(API_URL + 'forms/' + formId + '/responses', {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async getResponseById(responseId) {
    try {
      const res = await axios.get(API_URL + 'forms/responses/' + responseId, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async submitFormResponse(formId, responseData) {
    try {
      const res = await axios.post(API_URL + 'forms/' + formId + '/submit', responseData, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async deleteResponse(responseId) {
    try {
      const res = await axios.delete(API_URL + 'forms/responses/' + responseId, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async exportResponses(formId, format = 'excel') {
    try {
      const res = await axios.get(API_URL + 'forms/' + formId + '/export?format=' + format, {
        headers: AuthService.authHeader(),
        responseType: 'blob'
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Form Analytics
  async getFormAnalytics(formId) {
    try {
      const res = await axios.get(API_URL + 'forms/' + formId + '/analytics', {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async getResponseStats(formId) {
    try {
      const res = await axios.get(API_URL + 'forms/' + formId + '/stats', {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Form Templates
  async getFormTemplates() {
    try {
      const res = await axios.get(API_URL + 'forms/templates', {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async createFormFromTemplate(templateId, formData) {
    try {
      const res = await axios.post(API_URL + 'forms/templates/' + templateId + '/create', formData, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Form Sharing and Permissions
  async shareForm(formId, shareData) {
    try {
      const res = await axios.post(API_URL + 'forms/' + formId + '/share', shareData, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async updateFormPermissions(formId, permissions) {
    try {
      const res = await axios.patch(API_URL + 'forms/' + formId + '/permissions', permissions, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Form Settings
  async updateFormSettings(formId, settings) {
    try {
      const res = await axios.patch(API_URL + 'forms/' + formId + '/settings', settings, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Form Validation
  async validateForm(formData) {
    try {
      const res = await axios.post(API_URL + 'forms/validate', formData, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Search and Filter Forms
  async searchForms(query, filters = {}) {
    try {
      const params = new URLSearchParams({ query, ...filters });
      const res = await axios.get(API_URL + 'forms/search?' + params.toString(), {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Bulk Operations
  async bulkDeleteForms(formIds) {
    try {
      const res = await axios.post(API_URL + 'forms/bulk-delete', { formIds }, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async bulkArchiveForms(formIds) {
    try {
      const res = await axios.post(API_URL + 'forms/bulk-archive', { formIds }, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async bulkPublishForms(formIds) {
    try {
      const res = await axios.post(API_URL + 'forms/bulk-publish', { formIds }, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Form Categories and Tags
  async getFormCategories() {
    try {
      const res = await axios.get(API_URL + 'forms/categories', {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async getFormTags() {
    try {
      const res = await axios.get(API_URL + 'forms/tags', {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  // Form Notifications
  async getFormNotifications(formId) {
    try {
      const res = await axios.get(API_URL + 'forms/' + formId + '/notifications', {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  async updateFormNotifications(formId, notifications) {
    try {
      const res = await axios.patch(API_URL + 'forms/' + formId + '/notifications', notifications, {
        headers: AuthService.authHeader()
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }
}

export default new FormsService(); 